import { createAsyncThunk } from '@reduxjs/toolkit';
import sanityClient from '../../../lib/sanityClient';

export const fetchHome = createAsyncThunk('home/fetch', sanityClient.getHome);
